import { render, staticRenderFns } from "./ReturnedChecks.vue?vue&type=template&id=67d96954"
import script from "./ReturnedChecks.vue?vue&type=script&lang=js"
export * from "./ReturnedChecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports